export default {
  ApprovalStatus: {
    SUBMIT: '提出',
    RETRACT: '取り消し',
    APPROVED: '承認',
    REJECT: '拒否',
  },
  ConfigKey: {
    DEFAULT_AVATAR_PATH: 'デフォルトのアバターのパス',
    KRAMPUS_URL: 'KRAMPUSのURL',
    ADMIN_HOST: '管理画面のアドレス',
    MIN_DEPOSIT: '最小入金制限（米ドル）',
    MIN_WITHDRAWAL: '最小引き出し制限（米ドル）',
    UPLOAD_PATH: 'システムのルートディレクトリにアップロードされたファイル',
    FILE_PATH: 'ファイルのサブディレクトリ',
    REGISTER_URL_BASE: '登録のURLベース',
    JWT_VERSION_FRONT: 'JWT FRONTバージョン',
    JWT_VERSION_ADMIN: 'JWT ADMINバージョン',
    MAX_DEPOSIT: '最大入金額（米ドル）',
    MAX_WITHDRAWAL: '最大引き出し額（米ドル）',
    SENTRY_ENABLED: 'Sentryの有効化',
    SENTRY_URL: 'SentryのURL',
  },
  Currency: {
    USDT: 'USDT',
    BRL: 'レアル',
    INR: 'ルピー',
    USD: '米ドル',
    EUR: 'ユーロ',
    HKD: '香港ドル',
    IDR: 'ルピア',
    VND: 'ベトナムドン',
  },
  CustomerField: {
    NAME: '名前',
    MOBILE: '携帯番号',
    SEX: '性別',
    DOB: '誕生日',
    DISTRICT: '地域',
  },
  FlowChartType: {
    VERIFIED: '顧客認証プロセス',
    DEPOSIT: '入金処理プロセス',
    WITHDRAWAL: '出金処理プロセス',
  },
  FlowInfoType: {
    VERIFIED: '顧客認証',
    DEPOSIT: '入金処理',
    WITHDRAWAL: '出金処理',
  },
  IdentificationType: {
    ID_CARD: '身分証明書',
    PASSPORT: 'パスポート',
    DRIVER_LICENSE: '運転免許証',
    SOCIAL_INSURANCE_CARD: '社会保険カード',
    OTHER: 'その他',
  },
  ReceiveMethod: {
    BANK: '銀行',
    USDT: 'USDT',
    NET_PAY: '給料',
  },
  ResourceType: {
    ID: '身分情報',
    CUSTOMER_AVATAR: '顧客のアバター',
    IT_RECEIVE_AVATAR: '機関受取情報',
    PROCESS_FLOW: 'プロセスフロー',
    TRANSFER_PROOF: '転送証明',
  },
  Sex: {
    MALE: '男性',
    FEMALE: '女性',
    SECRET: '秘密',
  },
  TransferTransactionStatus: {
    TRANSFERRING: '転送待ち',
    TRANSFERRED: '転送済み',
    CONFIRMED: '受取済み',
    CANCELLED: 'キャンセル済み',
    FORCE_CONFIRMED: '受取済み（強制）',
    FORCE_CANCELLED: 'キャンセル済み（強制）',
    FAILED: '失敗した',
  },
  TransferRole: {
    CUSTOMER: '顧客',
    IT: '機関',
  },
  DurationType: {
    MINUTES: '分',
    HOURS: '時間',
  },
  Lang: {
    AUTO: '自動',
    EN: '英語',
    ZH_CN: '中国語（簡体字）',
    ZH_HK: '中国語（繁体字）',
    JA: '日本語',
    KO: '韓国語',
    PT: 'ポルトガル語',
    ID: 'インドネシア語',
  },
  CryptoNetwork: {
    TRC20: 'TRC20',
    ERC20: 'ERC20',
  },
  RoleType: {
    SUPER_USER: 'スーパーユーザー',
    ROLE_IT: '機関管理者',
    ROLE_AGENT: '代理管理者',
  },
  Country: {
    SOUTH_KOREA: '韓国',
    JAPAN: '日本',
    BRAZIL: 'ブラジル',
    INDIA: 'インド',
    TAIWAN: '台湾',
    INDONESIA: 'インドネシア',
    VIETNAM: 'ベトナム',
  },
  QMaxInvestmentOption: {
    HKD_300000: '$300,000',
    HKD_100: '$100',
  },
  QTriggerOption: {
    AT_LATEST_PRICE: '最新価格でのポジションクローズ',
    STOP_LOSS_NOT_TRIGGERED: 'ストップロスがポジションをクローズしない',
  },
  AutoCloseOption: {
    INSUFFICIENT_CAPITAL: '市場が私のポジションに不利な方向に進展し、私の口座に十分な資本がないため、',
    FAVORABLE_DIRECTION: '市場が私の有利なポジションに向かっている',
  },
  QTradingCountOption: {
    COUNT_100: '51〜100トレード',
    COUNT_50: '20〜50トレード',
    COUNT_LESS_THAN_20: '20トレード未満',
    COUNT_NONE: 'トレードなし',
  },
  QOtcLeverageOption: {
    BETWEEN_1_50_AND_1_100: '1:50〜1:100',
    BETWEEN_1_25_AND_1_50: '1:25〜1:50',
    BETWEEN_1_2_AND_1_25: '1:2〜1:25',
    NO_LEVERAGE: 'レバレッジを使用しない（1:1）',
  },
  QFinanceEducationOption: {
    WORKED_IN_FINANCIAL: '金融サービス業界での経験あり',
    PROFESSIONAL: '専門資格/または高等教育',
  },
  QOccupationOption: {
    EMPLOYEE: '従業員',
    SELF_EMPLOYED: '自営業',
    RETIRED: '退職',
    STUDENT: '学生',
    PROPERTY: '不動産',
  },
  QIndustryOption: {
    FINANCIAL_SERVICES: '金融サービス業界',
    INFORMATION_TECHNOLOGY: '情報技術業界',
    HEALTHCARE: '医療',
    RETAIL_AND_CONSUMER_GOODS: '小売・消費財業界',
    MANUFACTURING: '製造業',
    MEDIA_AND_ENTERTAINMENT: 'メディア・エンターテイメント業界',
    CONSTRUCTION_AND_REAL_ESTATE: '建設・不動産業界',
    ENERGY_AND_UTILITIES: 'エネルギー・公益事業業界',
    CONSULTING_AND_PROFESSIONAL_SERVICES: 'コンサルティング・専門サービス業界',
    OTHER: 'その他',
  },
  QFinancialAmountOption: {
    FIVE_M_PLUS: '$5,000,000以上',
    FIVE_M: '$2,000,000 - $5,000,000',
    TWO_M: '$1,000,000 - $2,000,000',
    ONE_M: '$500,000 - $1,000,000',
    FIVE_HUNDRED_K: '$200,000 - $500,000',
    TWO_HUNDRED_K: '$50,000 - $200,000',
    FIFTY_K: '$0 - $50,000',
  },
  QIncomeSourceOption: {
    EMPLOYMENT_INCOME: '雇用収入',
    PENSION_OR_GOVERNMENT_BENEFITS: '年金または政府給付',
    INVESTMENT_INCOME: '投資収入',
    INHERITANCE: '相続',
    PROPERTY_SALE: '不動産売却',
    BUSINESS_SALE: '事業売却',
  },
  QTradingFrequencyOption: {
    DAILY: '毎日',
    WEEKLY: '毎週',
    MONTHLY: '毎月',
  },
  QDepositMethodOption: {
    CREDIT_CARD: 'クレジットカード/デビットカード',
    BANK_TRANSFER: '銀行送金',
  },
  PaymentGateway: {
    PPAY: 'ppay支払い',
    CASH_PAY: 'cashpay支払い',
    UAT_EPAY: 'UAT epay支払い',
    PRO_EPAY: 'PRO epay支払い',
  },
  PayType: {
    RECEIVE: '入金',
    PAYMENT: '出金',
  },
  TransactionModel: {
    C2C: 'C2C',
    B2C: 'B2C',
    B2B: 'B2B',
    C2B: 'C2B',
  },
  TransactionCategory: {
    BANK: '銀行',
    TRANSFER: '送金',
    IFSC: 'インド決済-IFSC',
    PIX: 'ブラジル支払い-PIX',
  },
  FeeModel: {
    FIXED: '固定手数料',
    PERCENTAGE: '割合手数料',
  },
  RateMode: {
    USD_TO_TARGET: 'USDから目標通貨へ',
    TARGET_TO_USD: '目標通貨からUSDへ',
  },
  PaymentOrderStatus: {
    FAILED: '処理失敗',
    SUCCESS: '処理成功',
    PENDING: '処理保留中',
    CANCELED: '取消完了',
    PROCESSING: '処理中',
  },
  DepositPaymentOrderStatus: {
    FAILED: '入金失敗',
    SUCCESS: '入金成功',
    PENDING: '処理保留中',
    CANCELED: '取消完了',
    PROCESSING: '入金処理中',
  },
  WithdrawPaymentOrderStatus: {
    FAILED: '出金失敗',
    SUCCESS: '出金成功',
    PENDING: '処理保留中',
    CANCELED: '取消完了',
    PROCESSING: '出金処理中',
  },
  PaySystemOrderStatus: {
    GATEWAY_CREATE: 'GATEWAY_CREATE',
    CONFIRM: 'CONFIRM',
    CANCEL: 'CANCEL',
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    CLOSE: 'CLOSE',
    FREEZE: 'FREEZE',
    WITHDRAWN: 'WITHDRAWN',
    NO_REFUND_OF_HANDLING_FEE: 'NO_REFUND_OF_HANDLING_FEE',
  },
  ProviderType: {
    APPLE: 'APPLE',
    GOOGLE: 'GOOGLE',
    FACEBOOK: 'FACEBOOK',
    PASSWORD: 'PASSWORD',
    MAIL_PASSWORD: 'MAIL',
    PHONE_PASSWORD: 'PHONE',
  },
  PaymentChannel: {
    INDIA_UPI_1: 'UPIタイプ1（インド）',
    INDIA_NATIVE_1: 'ネイティブタイプ1（インド）',
    INDIA_UPI_2: 'UPIタイプ2（インド）',
    INDIA_NATIVE_2: 'ネイティブタイプ2（インド）',
    BRAZIL_PIX_1: 'PIXタイプ1（ブラジル）',
    BRAZIL_PIX_2: 'PIXタイプ2（ブラジル）',
    BRAZIL_PIX_FAST: 'PIXクイック（ブラジル）',
  },
  BankInfoExtType: {
    NORMAL: 'NORMAL',
    PIX_EXT: 'PIX_EXT',
    IFSC_EXT: 'IFSC_EXT',
    BANK_EXT: 'BANK_EXT',
    CRYPTO_CURRENCY_EXT: 'CRYPTO_CURRENCY_EXT',
  },
  PixType: {
    CPF: '個人識別番号 (パーソナル識別番号)',
    PHONE: '携帯番号 (モバイル番号)',
    EMAIL: '電子メールアドレス (Eメールアドレス)',
    EVP: 'バーチャルペイメントアドレス',
  },
  CryptoTokenType: {
    USDT_ERC20: 'USDT (ERC20)',
    USDT_TRC20: 'USDT (TRC20)',
    USDT_BEP20: 'USDT (BEP20)',
    ETHEREUM: 'Ethereum',
    BNB_BEP20: 'BNB (BEP20)',
    BTC: 'BTC',
    OTF_BEP20: 'OTF (BEP20)',
  },
  EpayCountryCode: {
    BR: 'ブラジル',
  },
  EpayGender: {
    MALE: '男性',
    FEMALE: '女性',
  },
  EpayIdType: {
    ID_CARD: 'IDカード',
    PASSPORT: 'パスポート',
  },
  EpayPurposeOfRemittance: {
    CorporatePayment: '法人支払い',
    Marketplace: '市場取引',
    ProfessionalServices: 'プロフェッショナル サービス',
    Payroll: '給与支払い',
    ExpensesReimbursement: '経費の払い戻し',
    RepresentationExpenses: 'ビジネス支払い',
    HiredPersonnel: '雇用された人',
    TraineesScholarships: '研修生/奨学金',
    ProductivityOrQualityPrizes: '生産性または品質賞',
    LayOffPayment: 'レイオフの支払い',
    FamilySupport: 'ファミリーサポート',
    Education: '教育',
    GiftAndOtherDonations: 'ギフトとその他の寄付',
    MedicalTreatment: '医療',
    MaintenanceOrOtherExpenses: 'メンテナンスまたはその他の費用',
    CarDriver: 'ドライバー',
    SoftwareLicense: 'ソフトウェアライセンス',
    HotelAccommodation: 'ホテル宿泊施設',
    AdvertisingAndOrPublicRelationsRelatedExpenses: '広告および/または広報関連費用',
    FeesForAdvisoryOrConsultingService: 'コンサルティングまたはコンサルティングサービス料金',
    BusinessRelatedInsurancePayment: 'ビジネス関連の保険支払い',
    InsuranceClaimsPayment: '保険金支払い',
  },
  Gender: {
    MALE: '男性',
    FEMALE: '女性',
    UNKNOWN: '不明',
    NOT_APPLICABLE: '該当しません',
  },
  BeneficiaryRelationShip: {
    BOYFRIEND: '彼氏',
    BUSINESS_PARTNER: 'パートナー',
    CHILDREN: '子供たち',
    COLLEAGUE: '同僚',
    EX_SPOUSE: '元配偶者',
    FIANCE: '婚約者「男」',
    FIANCEES: '婚約者「女」',
    FRIEND: '友達',
    GIRLFRIEND: '彼女',
    GRAND_PARENTS: '祖父母',
    PARENTS: '両親',
    RELATIVE_UNCLE_AUNTIE_COUSIN: '親戚/叔父/叔母/いとこ',
    SELF: '自分',
    SIBLING_BROTHER_SISTER: '同胞/兄弟/姉妹',
    SPOUSE: '配偶者',
    SUBSIDIARY_COMPANY: '子会社',
  },
};
